import React, { useMemo } from 'react';
import { useTheme } from '@mui/material';
import SectionCard from 'components/dashboard/chartmind/SectionCard';
import {
  dischargeInstructionTitle,
  sortDischargeInstructions,
} from 'utils/dischargeInstructions';

const useCategoryColors = () => {
  const theme = useTheme();
  return {
    medication_general: theme.palette.primary.main,
    medication_specific: theme.palette.primary.main,
    activity: theme.palette.info.main,
    diet: theme.palette.success.main,
    followup: theme.palette.secondary.main,
    warning_signs: theme.palette.error.main,
    wound_care: theme.palette.warning.main,
    other: theme.palette.grey[600],
  };
};

/**
 * One set of delivered discharge instructions, as the patient reads them.
 *
 * Shared by the patient's Discharge Instructions page and the page a scanned QR
 * opens, so both read identically.
 *
 * ⚠️ NEVER TRUNCATED. SectionCard previews at 600 characters by default, which is
 * right for the clinician's editing cards and wrong here: this is the patient's
 * only copy, and the part cut off is as likely to be a warning sign as anything.
 */
const DischargeInstructionCards = ({ instructions }) => {
  const colors = useCategoryColors();
  const ordered = useMemo(() => sortDischargeInstructions(instructions), [instructions]);

  return ordered.map((inst, idx) => (
    <SectionCard
      key={`${inst.title}-${idx}`}
      title={dischargeInstructionTitle(inst)}
      content={inst.prose}
      maxPreviewLength={Infinity}
      accentColor={colors[inst.category] || colors.other}
    />
  ));
};

export default DischargeInstructionCards;
